import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { loginSessions } from 'src/app/app-store/actions/session.actions';
import { CognitoService } from 'src/services/cognito.service';

@Component({
  selector: 'pharmacist-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  userId = '';
  password = '';
  pharmacyCode = '';

  constructor(private store: Store, private router: Router, private cognito: CognitoService) {}

  async ngOnInit() {
    const isLogin = await this.cognito.isAuthenticated();
    if (isLogin) {
      this.router.navigate(['/pharmacist/index']);
    }
  }

  login() {
    const cognitoLoginId = this.pharmacyCode !== '' ? `${this.pharmacyCode}-${this.userId}` : this.userId;
    this.store.dispatch(loginSessions({ email: cognitoLoginId, password: this.password, type: 'pharmacist' }));
  }
}
